var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7008 0.5H3.49062C1.89453 0.5 0.5 1.64844 0.5 3.22578V32.5008C0.5 34.0867 1.89453 35.5 3.49062 35.5H32.6922C34.2969 35.5 35.5 34.0773 35.5 32.5008V3.22578C35.5094 1.64844 34.2969 0.5 32.7008 0.5ZM11.3492 29.6742H6.33516V14.0844H11.3492V29.6742ZM9.01562 11.7141H8.97969C7.375 11.7141 6.33594 10.5195 6.33594 9.02422C6.33594 7.50156 7.40234 6.33516 9.04297 6.33516C10.6836 6.33516 11.6875 7.49297 11.7234 9.02422C11.7227 10.5195 10.6836 11.7141 9.01562 11.7141ZM29.6742 29.6742H24.6602V21.15C24.6602 19.1078 23.9305 17.7125 22.1164 17.7125C20.7305 17.7125 19.9102 18.65 19.5453 19.5633C19.4086 19.8914 19.3719 20.3383 19.3719 20.7945V29.6742H14.3578V14.0844H19.3719V16.2539C20.1016 15.2148 21.2414 13.7195 23.8938 13.7195C27.1852 13.7195 29.675 15.8891 29.675 20.5664L29.6742 29.6742Z",
    fill: "#3971E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e9fdcc5cc12b3b5900ad3391296fced6.svg";
export { ForwardRef as ReactComponent };